import axios from 'axios';
//import config from '../../config';
import { config} from '../../config'
//import {history} from '../../store';

export const getUserRolesFullByUserIdApi = (userId)=>{
    const url = `${config.apiUrl}/v1/userRoles/full/${userId}`;
    return axios.get(url)
    .then(response => response.data).catch(err => {  return { status:false , error:err.response}  });
 }

 export const deleteUserRolesApi = (userRoleId)=>{
    const url = `${config.apiUrl}/v1/userRoles/${userRoleId}`;
    return axios.delete(url)
    .then(response => response.data);
 }
 export const postUserRolesApi = (userRole)=>{ 
    const url = `${config.apiUrl}/v1/userRoles/`;
    return axios.post(url,userRole) 
    .then(response => response.data);
 }

 export const putUserRolesApi = (userRole)=>{
    const url = `${config.apiUrl}/v1/userRoles/`;
    return axios.put(url,userRole)
    .then(response => response.data);
 }

 export const getRolesAllApi = async()=>{
    
   const url = `${config.apiUrl}/v1/roles/`;
   return await axios.get(url)
   .then(response => response.data)
}
export const getRolesCustomDetailApi = async()=>{
   const url = `${config.apiUrl}/v1/roles/customDetail/list`;
    return await axios.get(url)
    .then(response => response.data)
 }

 export const getSAYSProjectApi = async()=>{
  const url = `${config.apiUrl}/v1/roles/says/project`;
   return await axios.get(url)
   .then(response => response.data)
}

export const getRoleUserListPDFByIdApi = (id)=>{
   const url = `${config.apiUrl}/v1/roles/userList/pdf/${id}`;
   return axios.get(url , {
      method: 'GET',
      responseType: 'blob',
   })  
   .then(response => {
      const file = new Blob(
         [response.data], 
         {type: 'application/pdf'});
         return file;
   });
} 
export const getRoleUserListPDFByAppIdApi = (id)=>{
   const url = `${config.apiUrl}/v1/roles/userList/pdf/byAppId/${id}`;
   return axios.get(url , {
      method: 'GET',
      responseType: 'blob',
   })  
   .then(response => {
      const file = new Blob(
         [response.data], 
         {type: 'application/pdf'});
         return file;
   });
} 

export const getRoleUserListPDFAllApi = (id)=>{
   const url = `${config.apiUrl}/v1/roles/userList/pdf/`;
   return axios.get(url , {
      method: 'GET',
      responseType: 'blob',
   })  
   .then(response => {
      const file = new Blob(
         [response.data], 
         {type: 'application/pdf'});
         return file;
   });
} 

// ------------------------------------------------------------
// JSON listeler (RoleManagePage'de tablo göstermek için)
// ------------------------------------------------------------
export const getRoleUserListByIdApi = async (roleId) => {
   const url = `${config.apiUrl}/v1/roles/userList/${roleId}`;
   return await axios.get(url).then((r) => r.data).catch((err) => ({ status: false, error: err.response }));
};

export const getRoleUserListByAppIdApi = async (appId) => {
   const url = `${config.apiUrl}/v1/roles/userList/byAppId/${appId}`;
   return await axios.get(url).then((r) => r.data).catch((err) => ({ status: false, error: err.response }));
};

export const getRoleUserListAllApi = async () => {
   const url = `${config.apiUrl}/v1/roles/userList/all`;
   return await axios.get(url).then((r) => r.data).catch((err) => ({ status: false, error: err.response }));
};